import React from "react";
import { Link } from "react-router-dom";
import Reveal from "../components/Reveal";
import PropertyCard from "../components/PropertyCard";
import GoldDivider from "../components/GoldDivider";
import { properties } from "../data/properties";
import { ArrowRight } from "lucide-react";

const HERO =
    "https://images.unsplash.com/photo-1762430047160-db0e2670c533?auto=format&fit=crop&w=1800&q=80";

const Commercial = () => {
    const list = properties.filter((p) => p.category === "commercial");

    return (
        <div data-testid="page-commercial">
            <section className="relative pt-40 pb-28 overflow-hidden">
                <div
                    className="absolute inset-0 opacity-55"
                    style={{ backgroundImage: `url(${HERO})`, backgroundSize: "cover", backgroundPosition: "center" }}
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-brand-jet" />
                <div className="relative max-w-5xl mx-auto px-6 text-center">
                    <Reveal>
                        <p className="text-[0.7rem] tracking-[0.55em] uppercase text-brand-gold mb-6">
                            Commercial Capital Markets
                        </p>
                        <h1 className="font-serif-editorial text-5xl md:text-6xl lg:text-7xl text-brand-silver leading-[1.05]">
                            Institutional assets, <span className="italic text-brand-champagne">quietly brokered.</span>
                        </h1>
                        <p className="mt-10 text-brand-silver/75 text-lg max-w-2xl mx-auto leading-relaxed">
                            Office towers, hospitality, logistics, mixed-use, and adaptive-reuse —
                            advised for family offices, funds, and private investors across Southern Nevada.
                        </p>
                    </Reveal>
                </div>
            </section>

            <section className="py-24">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <div className="grid md:grid-cols-12 gap-8">
                        {list.map((p, i) => (
                            <Reveal key={p.id} delay={i * 90} className={i === 0 ? "md:col-span-8" : "md:col-span-4"}>
                                <PropertyCard p={p} featured={i === 0} />
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            <GoldDivider />

            <section className="py-28 text-center max-w-3xl mx-auto px-6">
                <Reveal>
                    <p className="font-cursive text-brand-gold text-5xl wordmark-glow">Off-market opportunities.</p>
                    <p className="mt-6 text-brand-silver/70 max-w-xl mx-auto">
                        The majority of our commercial mandates are never marketed publicly.
                        Request a confidential brief.
                    </p>
                    <Link
                        to="/contact"
                        className="mt-10 inline-flex items-center gap-2 text-xs tracking-[0.35em] uppercase border border-brand-gold text-brand-gold px-10 py-5 hover:bg-brand-gold hover:text-brand-jet transition-all duration-500"
                        data-testid="commercial-cta-brief"
                    >
                        Request Brief <ArrowRight size={14} />
                    </Link>
                </Reveal>
            </section>
        </div>
    );
};

export default Commercial;
